var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.7207 4.74901C24.3273 4.34017 23.673 4.34017 23.2796 4.74901L16.9694 11.3068C16.358 11.9421 16.8083 13.0002 17.6899 13.0002H21.0002V21.0002H13.0002V17.6899C13.0002 16.8083 11.9421 16.358 11.3068 16.9694L4.74901 23.2796C4.34017 23.673 4.34017 24.3273 4.74901 24.7207L11.3068 31.031C11.9421 31.6423 13.0002 31.192 13.0002 30.3104V27.0002H21.0002V35.0002H17.6899C16.8083 35.0002 16.358 36.0582 16.9694 36.6935L23.2796 43.2513C23.673 43.6602 24.3273 43.6602 24.7207 43.2513L31.031 36.6935C31.6423 36.0582 31.192 35.0002 30.3104 35.0002H27.0002V27.0002H35.0002V30.3104C35.0002 31.192 36.0582 31.6423 36.6935 31.031L43.2513 24.7207C43.6602 24.3273 43.6602 23.673 43.2513 23.2796L36.6935 16.9694C36.0582 16.358 35.0002 16.8083 35.0002 17.6899V21.0002H27.0002V13.0002H30.3104C31.1921 13.0002 31.6423 11.9421 31.031 11.3068L24.7207 4.74901Z",
    fill: "#003E6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveIcon);
export default __webpack_public_path__ + "static/media/MoveIcon.4fd143b20fbf01531d50d54ef4ed63cb.svg";
export { ForwardRef as ReactComponent };